import React from 'react';
import VoiceAssistant from './VoiceAssistant';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>🎤 Brainchimps AI Assistant</h1>
        <p>Real-time voice conversation with your friendly Brainchimps assistant</p>
        <p style={{ fontSize: '0.9rem', opacity: 0.8, marginTop: '0.5rem' }}>
          🇩🇪 Configured for German (Deutsch) by default • Powered by GPT-4o
        </p>
      </header>
      <main className="App-main">
        <VoiceAssistant />
      </main>
      <footer className="App-footer">
        <div className="footer-links">
          <a href="https://www.brainchimps.com/impressum" target="_blank" rel="noreferrer">Impressum</a>
          <span className="separator">•</span>
          <a href="https://www.brainchimps.com/datenschutz" target="_blank" rel="noreferrer">Datenschutz</a>
        </div>
      </footer>
    </div>
  );
}

export default App;